function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 8.09658H7V4.08869H5.5V8.09658ZM3 8.09658H4.5V4.08869H3V8.09658ZM4 3.08671H6V2.08474H4V3.08671ZM8.5 3.08671H7V2.08474C7 1.53215 6.5515 1.08276 6 1.08276H4C3.4485 1.08276 3 1.53215 3 2.08474V3.08671H1.5C1.2235 3.08671 1 3.31115 1 3.5877C1 3.86424 1.2235 4.08869 1.5 4.08869H2V8.59757C2 8.87411 2.2235 9.09855 2.5 9.09855H7.5C7.7765 9.09855 8 8.87411 8 8.59757V4.08869H8.5C8.7765 4.08869 9 3.86424 9 3.5877C9 3.31115 8.7765 3.08671 8.5 3.08671Z",
  fill: "#212B36"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 8,
  height: 9
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 8.09658H7V4.08869H5.5V8.09658ZM3 8.09658H4.5V4.08869H3V8.09658ZM4 3.08671H6V2.08474H4V3.08671ZM8.5 3.08671H7V2.08474C7 1.53215 6.5515 1.08276 6 1.08276H4C3.4485 1.08276 3 1.53215 3 2.08474V3.08671H1.5C1.2235 3.08671 1 3.31115 1 3.5877C1 3.86424 1.2235 4.08869 1.5 4.08869H2V8.59757C2 8.87411 2.2235 9.09855 2.5 9.09855H7.5C7.7765 9.09855 8 8.87411 8 8.59757V4.08869H8.5C8.7765 4.08869 9 3.86424 9 3.5877C9 3.31115 8.7765 3.08671 8.5 3.08671Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

function SvgSmallDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDeleteIcon);
export default __webpack_public_path__ + "static/media/small-delete-icon.dee57479.svg";
export { ForwardRef as ReactComponent };